// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2ej32","dragIcon":"Choice_dragIcon__2TpIG","left":"Choice_left__1eD9u","input":"Choice_input__1CwH1"};